import { Footer as UiFooter } from '@linka/ui/footer';
import { useTranslation } from 'react-i18next';
import { useCopyToClipboard } from '@/ui/hooks/use-copy-to-clipboard';

const participantAreaUrl = import.meta.env.DEV ? import.meta.env.VITE_PUBLIC_LP_URL : 'https://www.linka.la';

export const Footer = () => {
  const { t } = useTranslation();
  const [, copy] = useCopyToClipboard();
  const currentYear = new Date().getFullYear();

  return (
    <UiFooter
      copyrightText={t('footer.copyright', { year: currentYear })}
      links={[
        {
          key: 'policy',
          label: t('footer.privacy-policy'),
          onClick: () => {
            window.location.href = `${participantAreaUrl}/terms-and-politics/pt`;
          },
        },
        {
          key: 'terms',
          label: t('footer.terms-of-service'),
          onClick: () => {
            window.location.href = 'https://policies.google.com/terms';
          },
        },
      ]}
      helpLink={{ key: 'contact', label: t('footer.contact-us'), onClick: () => copy('comercial@linka.la') }}
      areaLink={{ key: 'area', label: t('footer.participant-area'), href: participantAreaUrl }}
    />
  );
};
